goog.provide("shadow.js.shim.module$src$svg$wpp$content$live_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$live_svg");
shadow.js.shim.module$src$svg$wpp$content$live_svg = shadow.js.nativeProvides["src/svg/wpp/content/live.svg"] = shadow$bridge("src/svg/wpp/content/live.svg");
module$shadow_js_shim_module$src$svg$wpp$content$live_svg.default = shadow.js.shim.module$src$svg$wpp$content$live_svg;
